import { render, staticRenderFns } from "./NotifyList.vue?vue&type=template&id=6f03beb8&scoped=true"
import script from "./NotifyList.vue?vue&type=script&lang=js"
export * from "./NotifyList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f03beb8",
  null
  
)

export default component.exports